import { render, staticRenderFns } from "./EditMedia.vue?vue&type=template&id=83a7113e&scoped=true&"
import script from "./EditMedia.vue?vue&type=script&lang=js&"
export * from "./EditMedia.vue?vue&type=script&lang=js&"
import style0 from "./EditMedia.vue?vue&type=style&index=0&id=83a7113e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a7113e",
  null
  
)

export default component.exports